import React from 'react';
interface LogoProps {
  variant?: 'dark' | 'white';
  className?: string;
}
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/o5jZysHEiJedDY1LG56coD/LOGO-MILANGELAS-SOUL-GARDEN-02.png';
export function Logo({
  variant = 'dark',
  className = ''
}: LogoProps) {
  return <img src={LOGO_URL} alt="Milangela's Soul Garden" className={className} style={variant === 'white' ? {
    filter: 'brightness(0) invert(1)'
  } : undefined} data-id="element-154" />;
}